import { render, staticRenderFns } from "./availabilityList.vue?vue&type=template&id=03944270&scoped=true&"
import script from "./availabilityList.vue?vue&type=script&lang=js&"
export * from "./availabilityList.vue?vue&type=script&lang=js&"
import style0 from "./availabilityList.vue?vue&type=style&index=0&id=03944270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03944270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VCard,VDivider,VFlex,VLayout,VList,VListTile,VListTileContent})
